module.exports = __webpack_public_path__ + "img/logo.cd0c5104.png";